'use client'

import Image from 'next/image';
import {useLogout, usePrivy} from "@privy-io/react-auth";
import {useRouter} from "next/navigation";
import {useAppDispatch} from "@/lib/redux/hooks";
import {close} from "@/lib/redux/slices/menuSlice";
import {clearAllNFTData} from "@/lib/redux/slices/metaAnchorSlice";

export default function LogoutMenuItem() {
    const {ready, authenticated} = usePrivy();
    const router = useRouter();
    const dispatch = useAppDispatch();

    const {logout} = useLogout({
        onSuccess: () => {
            dispatch(close());
            dispatch(clearAllNFTData());

            // Small delay to ensure Redux state updates before navigation
            setTimeout(() => {
                router.push('/login', {scroll: false});
            }, 0);
        }
    });

    const isDisabled = !ready || !authenticated;

    return (

        <button disabled={isDisabled}
                onClick={logout}
                className="flex gap-6 justify-between items-center">
            <div
                className="flex justify-center items-center w-[52px] h-[52px] border border-grey-02 rounded-[5px] bg-dark-05">
                <Image
                    src={'/icons/icon-menu-logout.svg'}
                    width={20}
                    height={20}
                    alt={""}
                    style={{
                        objectFit: 'cover'
                    }}>
                </Image>
            </div>
            <span className="text-[#E24756] text-[24px] uppercase flex-1">LOGOUT</span>
        </button>
    );
}